<div class="card p-3 h-100">
	<div class="donut-title">{{ title }}</div>
	<div class="donut-body">
		<svg [attr.viewBox]="'0 0 ' + viewBoxSize + ' ' + viewBoxSize" class="donut-svg">
			<g [attr.transform]="'translate(' + (viewBoxSize / 2) + ',' + (viewBoxSize / 2) + ') rotate(-90)'">
				<circle *ngIf="donutSlices.length === 0"
					[attr.r]="radius"
					fill="none"
					stroke="var(--line)"
					[attr.stroke-width]="strokeWidth"></circle>
				<circle *ngFor="let slice of donutSlices"
					[attr.r]="radius"
					fill="none"
					[attr.stroke]="slice.color"
					[attr.stroke-width]="strokeWidth"
					[attr.stroke-dasharray]="slice.dashArray"
					[attr.stroke-dashoffset]="slice.dashOffset"
					stroke-linecap="butt"></circle>
			</g>
			<text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" class="donut-total">{{ total }}</text>
		</svg>
		<ul class="donut-legend">
			<li *ngFor="let slice of donutSlices">
				<span class="dot" [style.background]="slice.color"></span>
				<span class="lbl">{{ slice.label }}</span>
				<b>{{ slice.value }}</b>
			</li>
		</ul>
	</div>
</div>
